import { defineStore } from "pinia"

export const useCurrentBlock = defineStore('currentBlock', {
  state: () => ({
    block: {}
  }),
  actions: {}
})